module.exports = __webpack_public_path__ + "static/media/personal-agreement-bg.94a5621f.png";